import { combineReducers } from "redux";
import roles from "../features/admin/role_permmission/role/Slice";

const customers = combineReducers({
  roles: roles,
});

export default customers;
